export default "__VITE_ASSET__rXCyJf1O__"